/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Chat completion request
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * OpenAI-compatible messages (role, content)
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ChatRequest
     */
    messages: Array<{ [key: string]: any; }>;
    /**
     * Model/deployment name (optional; instance default used if null)
     * @type {string}
     * @memberof ChatRequest
     */
    model?: string;
    /**
     * Optional context: featureTag, requestId for attribution
     * @type {{ [key: string]: any; }}
     * @memberof ChatRequest
     */
    context?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ChatRequest interface.
 */
export function instanceOfChatRequest(value: object): value is ChatRequest {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function ChatRequestFromJSON(json: any): ChatRequest {
    return ChatRequestFromJSONTyped(json, false);
}

export function ChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': json['messages'],
        'model': json['model'] == null ? undefined : json['model'],
        'context': json['context'] == null ? undefined : json['context'],
    };
}

export function ChatRequestToJSON(json: any): ChatRequest {
    return ChatRequestToJSONTyped(json, false);
}

export function ChatRequestToJSONTyped(value?: ChatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': value['messages'],
        'model': value['model'],
        'context': value['context'],
    };
}

